module.exports = __webpack_public_path__ + "static/media/catto.1060d225.jpg";